export const version = "abi/5.1.2";
